import React from 'react';
import PropTypes from 'prop-types';
import routes from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
import openErrorMsgForm from '~c/popups/ErrorSender';
import PopupClose from '../Close';

class PassRestorationReset extends React.Component {
  state = {
    password: '',
    passwordConfirm: '',
    errorMessage: '',
    spinnerState: spinnerStates.done,
  };

  /**
   * @description validate password. Valide one is if length >= 6 symbols
   *
   * @param {string} pass
   *
   * @returns {boolean} true if valid
   */
  checkPassword = pass => {
    return pass.length >= 6;
  };

  requestSetPassword = e => {
    e.preventDefault();
    // const trueFetch = fetch;
    // fetch = fakeFetch({ status: 'success' });

    // FIXE: hardcoded cookies
    // const cookie =
    //   'PHPSESSID=17b3ce69f2f7d7ff7c6a8481bdc28c56; BITRIX_SM_CITY_SELECTED=samara1223; BITRIX_SM_SOUND_LOGIN_PLAYED=Y; BITRIX_SM_UIDH=68d67cf518a72b1a80188fc244e94131; BITRIX_SM_UIDL=%252B79277581813; BITRIX_SM_LOGIN=%252B79277581813';

    const options = {
      method: 'POST',
      headers: {
        // cookie,
        'content-type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        PASSWORD: this.state.password,
        CONFIRM_PASSWORD: this.state.passwordConfirm,
      }),
    };

    this.setState({ errorMessage: '', spinnerState: spinnerStates.pending });
    fetch(routes.user.setPass, options)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          this.props.onRegCompliteCallback();
          this.setState({ spinnerState: spinnerStates.done });
          if (this.props.onRegCompliteLocation !== '') {
            window.location.assign(this.props.onRegCompliteLocation);
          } else {
            window.location.reload();
          }
        } else if (json.status === 'error') {
          // TODO: panic!
          this.setState({
            errorMessage: json.errors[0].message,
            spinnerState: spinnerStates.done,
          });
        }
      })
      .catch((err) => {
        this.setState({
          errorMessage: messages.serverTimeout,
          spinnerState: spinnerStates.done,
        });
        const errorText = `${err.name} : ${err.message}`;
        const title = document.getElementsByTagName('h1')[0]?.innerHTML || '';
        const currentLocation = window.location.pathname;
        const error = {
          errors: errorText,
          page: `Сброс пароля. Страница: ${title}. URL: ${currentLocation}`
        };
        openErrorMsgForm(error);
      });
  };

  render() {
    return (
      <React.Fragment>
        <div className="popup auth">
          <div className="popup__close-container close_auth"><PopupClose/></div>
          <p className="heading heading--2">{this.props.header}</p>
          <form className="auth__form" action="">
            <label className="inp" htmlFor="password">
              <input autoComplete="off"
                className="inp__field"
                type="password"
                name="password"
                id="password"
                placeholder=" "
                onBlur={() => {
                  if (!this.checkPassword(this.state.password)) {
                    this.setState({
                      errorMessage: messages.passwordToShort,
                    });
                  } else {
                    this.setState({
                      errorMessage: '',
                    });
                  }
                }}
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
              />
              <p className="inp__label">Введите новый пароль</p>
            </label>
            <label className="inp" htmlFor="passwordConfirm">
              <input autoComplete="off"
                className="inp__field"
                type="password"
                name="repeat-password"
                id="passwordConfirm"
                placeholder=" "
                value={this.state.passwordConfirm}
                onBlur={() => {
                  if (this.state.password !== this.state.passwordConfirm) {
                    this.setState({
                      errorMessage: messages.passwordMismatch,
                    });
                  } else {
                    this.setState({
                      errorMessage: '',
                    });
                  }
                }}
                onChange={e =>
                  this.setState({ passwordConfirm: e.target.value })
                }
              />
              <p className="inp__label">Повторите пароль</p>
            </label>
            <button
              type="submit"
              className="btn btn--primary"
              onClick={this.requestSetPassword}
            >
              {this.state.spinnerState === spinnerStates.done ? (
                this.props.buttonCaption
              ) : (
                <React.Fragment>
                  <div className="invisible">{this.props.buttonCaption}</div>
                  <Loader
                    spinnerState={this.state.spinnerState}
                    spinnerPosition={spinnerPositions.absolute}
                    className="loader--white"
                  />
                </React.Fragment>
              )}
            </button>
            {this.state.errorMessage !== '' ? (
              <div className="error error__unique error__unique--left0 error__unique--top20 error--center error--red">
                {this.state.errorMessage}
              </div>
            ) : null}
          </form>
        </div>
      </React.Fragment>
    );
  }
}

PassRestorationReset.defaultProps = {
  header: 'Восстановление пароля',
  buttonCaption: 'Сбросить пароль',
  onRegCompliteCallback: () => {},
  onRegCompliteLocation: '/profile',
};

PassRestorationReset.propTypes = {
  header: PropTypes.string,
  buttonCaption: PropTypes.string,
  onRegCompliteCallback: PropTypes.func,
  onRegCompliteLocation: PropTypes.string,
};

export default PassRestorationReset;
